import { toast } from "sonner"
import { AppError } from "../types/AppError"

type ToastOptions = {
    duration?: number
    action?: {
        label: string
        onClick: () => void
    }
}

class ToastService {
    success(message: string, options?: ToastOptions) {
        toast.success(message, options)
    }

    error(error: string | AppError, options?: ToastOptions) {
        let msg = ''
        if (typeof error === 'string') {
            msg = error
        } else {
            msg = error.message.toString()
        }
        toast.error(msg, options)
    }

    info(message: string, options?: ToastOptions) {
        toast.info(message, options)
    }

    warning(message: string, options?: ToastOptions) {
        toast.warning(message, options)
    }

    // Generic show method for custom toasts
    show(message: string | React.ReactNode, options?: ToastOptions) {
        toast(message, options)
    }

    // Dismiss a specific toast or all toasts
    dismiss(id?: string | number) {
        toast.dismiss(id)
    }
}

export const toastService = new ToastService()
